import React from "react";
import { PropTypes } from "prop-types";
import { mergeOrOverrideCss } from "../../../common/utils";
import { observer } from "mobx-react";

function MrbPageContentSidebar({
    children,
    classNameOverride,
    classNameExtend,
}) {
    return (
        <div
            className={mergeOrOverrideCss(
                "c-content__sidebar",
                classNameOverride,
                classNameExtend
            )}
        >
            {children}
        </div>
    );
}

MrbPageContentSidebar.propTypes = {
    classNameOverride: PropTypes.string,
    classNameExtend: PropTypes.string,
    children: PropTypes.any,
};

export default observer(MrbPageContentSidebar);
